__turbopack_context__.v({
  "callout": "ProductCategory-module-scss-module__a0NNyq__callout",
  "flushBottom": "ProductCategory-module-scss-module__a0NNyq__flushBottom",
  "fullWidth": "ProductCategory-module-scss-module__a0NNyq__fullWidth",
  "gridCard": "ProductCategory-module-scss-module__a0NNyq__gridCard",
  "isRounded": "ProductCategory-module-scss-module__a0NNyq__isRounded",
  "landscape": "ProductCategory-module-scss-module__a0NNyq__landscape",
  "productGrid": "ProductCategory-module-scss-module__a0NNyq__productGrid",
  "productGridFlex": "ProductCategory-module-scss-module__a0NNyq__productGridFlex",
});
